import { SpecFilterGroup } from '@/components/catalogue/products/useFilteredProducts';
import { FC, PropsWithChildren, useMemo } from 'react';
import { create } from 'zustand';
import { Manufacturer } from '../api/contracts/catalog/types';
import { CatalogueExplorerFilterContext, CatalogueExplorerFilterService } from './useCatalogueExplorerFilterService';

interface Props {}

export const CatalogueExplorerFilterProvider: FC<PropsWithChildren<Props>> = ({ children }) => {
  const store = useMemo(
    () =>
      create<CatalogueExplorerFilterService>((set, get) => ({
        specFilters: [],
        setSpecFilter: (specs: SpecFilterGroup[]) => {
          set({ specFilters: specs });
        },
        clearSpec: (spec: string) => {
          let newFilters = get().specFilters.map(f => ({ queries: f.queries.filter(q => q !== spec) }));

          newFilters = newFilters.filter(n => n.queries.length > 0);

          set({ specFilters: newFilters });
        },
        manufacturerFilters: [],
        setManufacturerFilters: (manufacturers: Manufacturer[]) => {
          set({ manufacturerFilters: manufacturers });
        },
        clearManufacturer: (manufacturerId: string) => {
          const newFilters = get().manufacturerFilters.filter(filter => filter.id !== manufacturerId);

          set({ manufacturerFilters: newFilters });
        },
        clearAll: () => {
          set({ specFilters: [], manufacturerFilters: [] });
        }
      })),
    []
  );

  return <CatalogueExplorerFilterContext.Provider value={store}>{children}</CatalogueExplorerFilterContext.Provider>;
};
